import moment from 'moment';
import Moment from 'moment-timezone';

// Moment.tz.setDefault('America/Los_Angeles');

moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%ds',
    ss: '%ds',
    m: '%dm',
    mm: '%dm',
    h: '%dh',
    hh: '%dh',
    d: '%dd',
    dd: '%dd',
    w: '%dw',
    ww: '%dw',
    M: '%dM',
    MM: '%dM',
    y: '%dy',
    yy: '%dy',
  },
});

export type IMoment = moment.Moment;

export default Moment;
